"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFeedItemId = void 0;
const getFeedItemId = (data) => {
    if (!data.userId || !data.entityType || !data.entityId) {
        throw new Error('Missing feedItem data');
    }
    return `${data.userId}/${data.entityType}/${data.entityId}`;
};
exports.getFeedItemId = getFeedItemId;
